<template>
  <!-- you can rename class or id for this component, please put your comment what you need for styling needs -->

  <div :class="nameclass || 'numberDefaultClass'">
    <!-- for each component have default label and classname, 
    you can inherit when you call the component-->
    <label :id="idname || 'labeldefaultnumber'">{{ label }}</label>
    <b-form-input
      size="lg"
      v-bind="$attrs"
      type="number"
      v-on="$listeners"
      :value="value"
      @input="$emit('update', $event)"
      :style="{
        backgroundColor: value ? 'rgba(79, 208, 110,0.2)' : 'aliceblue',
      }"
      onkeydown="return event.keyCode !== 69 && event.keyCode !== 187 && event.keyCode !== 189"
    ></b-form-input>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: ["value", "label", "nameclass", "idname"],
  model: {
    prop: "value",
    event: "update",
  },
};
</script>
